// extracted by mini-css-extract-plugin
export var statItem = "_m9-1";
export var statsRow = "_m9-0";